import {
  Text,
  CircularProgress,
  CircularProgressLabel,
  Center,
  chakra,
} from "@chakra-ui/react";
import { SendLink } from "@components/ActivityTypes/Send";
import { getPercentage, handleToolLinkClick } from "@utils/helpers";
import { LinkIcon, ArrowUpRight } from "@components/Svg";

const SendResultsUI = ({
  title,
  content,
  link,
  options,
  response,
  numberOfParticipants,
  settings,
  onLinkClick,
}) => {
  // For blast mode, use all participants except host
  // For targeted mode, use initial participant count
  const activityParticipants = settings?.blast
    ? numberOfParticipants - 1 || 0
    : settings?.initialParticipant?.length - 1 || 0;

  const participantNumber = numberOfParticipants || activityParticipants;
  const responseNumber = response?.length || 0;
  const percentage = getPercentage(responseNumber, participantNumber);
  const roundedPercentage = percentage?.toFixed(0) || 0;

  // Use link prop directly, fallback to options for backward compatibility
  const linkText =
    link || (options && options.length > 0 ? options[0]?.option : null);

  const handleLinkClick = () => {
    if (onLinkClick) {
      onLinkClick(linkText);
    } else {
      // Fallback behavior for storybook or when no handler provided
      console.log("Link clicked:", linkText);
    }
  };

  return (
    <>
      {content && (
        <Text fontSize="12px" color="dark.300" my={2}>
          {content}
        </Text>
      )}
      {linkText && (
        <SendLink
          text={linkText}
          handleClick={handleLinkClick}
          beforeIcon={<LinkIcon color="dark.200" mr={2} width="12px" />}
          afterIcon={
            <ArrowUpRight ml={1} color="green.500" mr={1} width="10px" />
          }
        />
      )}
      <Center m="5px 0">
        <CircularProgress
          value={roundedPercentage}
          size="120px"
          color="blue.500"
          thickness="10px"
          capIsRound={true}
          trackColor="blue.50"
        >
          <CircularProgressLabel
            fontSize="16px"
            fontWeight="700"
            color="gray.800"
            display="inline-grid"
          >
            {roundedPercentage}%
            <chakra.span fontSize="10px" fontWeight="400" color="gray.400">
              Viewed
            </chakra.span>
          </CircularProgressLabel>
        </CircularProgress>
      </Center>
    </>
  );
};

export default SendResultsUI;
